import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Loader2, Save, AlertTriangle } from "lucide-react";

export default function InventoryManager() {
  const [rows, setRows] = useState(null);
  const [savingId, setSavingId] = useState("");

  const load = async () => {
    const { data } = await api.get("/owner/menu");
    const flat = [];
    for (const c of data.categories) for (const it of c.items) {
      flat.push({
        id: it.id, name: it.name, category: c.name,
        stock_qty: it.inventory?.stock_qty ?? 0,
        track: it.inventory?.track ?? false,
        low_stock_threshold: it.inventory?.low_stock_threshold ?? 5,
      });
    }
    setRows(flat);
  };
  useEffect(() => { load(); }, []);

  const update = (id, patch) => setRows((r) => r.map((x) => x.id === id ? { ...x, ...patch } : x));

  const save = async (row) => {
    setSavingId(row.id);
    try {
      await api.put(`/owner/inventory/${row.id}`, { stock_qty: parseInt(row.stock_qty) || 0, track: row.track, low_stock_threshold: parseInt(row.low_stock_threshold) || 0 });
      toast.success("Inventario actualizado");
    } catch (e) { toast.error(apiErr(e)); } finally { setSavingId(""); }
  };

  if (!rows) return <div className="py-20 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div>;

  return (
    <div className="rounded-xl border border-neutral-200 bg-white overflow-hidden">
      <table className="w-full text-sm" data-testid="inventory-table">
        <thead>
          <tr className="text-left text-neutral-500 border-b border-neutral-100">
            <th className="px-4 py-3 font-medium">Plato</th>
            <th className="px-4 py-3 font-medium text-center">Controlar stock</th>
            <th className="px-4 py-3 font-medium text-right">Cantidad</th>
            <th className="px-4 py-3 font-medium text-right">Umbral bajo</th>
            <th className="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const low = r.track && r.stock_qty <= r.low_stock_threshold;
            return (
              <tr key={r.id} className="border-b border-neutral-50" data-testid={`inv-row-${r.id}`}>
                <td className="px-4 py-3">
                  <div className="font-medium flex items-center gap-2">{r.name} {low && <AlertTriangle className="w-4 h-4 text-amber-500" />}</div>
                  <div className="text-xs text-neutral-400">{r.category}</div>
                </td>
                <td className="px-4 py-3 text-center"><Switch checked={r.track} onCheckedChange={(v) => update(r.id, { track: v })} data-testid={`inv-track-${r.id}`} /></td>
                <td className="px-4 py-3 text-right"><Input type="number" className="w-24 ml-auto text-right" value={r.stock_qty} onChange={(e) => update(r.id, { stock_qty: e.target.value })} disabled={!r.track} data-testid={`inv-qty-${r.id}`} /></td>
                <td className="px-4 py-3 text-right"><Input type="number" className="w-24 ml-auto text-right" value={r.low_stock_threshold} onChange={(e) => update(r.id, { low_stock_threshold: e.target.value })} disabled={!r.track} /></td>
                <td className="px-4 py-3 text-right"><Button size="sm" variant="outline" onClick={() => save(r)} disabled={savingId === r.id} data-testid={`inv-save-${r.id}`}>{savingId === r.id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}</Button></td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
